module.exports = "/_next/static/images/ye-dc0bba0764d54817e2d91fb83ba8a29d.svg";